import isPropValid from '@emotion/is-prop-valid';
import { ReactNode } from 'react';
import { StyleSheetManager, ThemeProvider as StyledComponentsThemeProvider } from 'styled-components';

import { theme } from './ui/theme';

interface ThemeProviderProps {
    children: ReactNode;
}

// This implements the default behavior from styled-components v5
function shouldForwardProp(propName: string, target: any) {
    if (typeof target === 'string') {
        // For HTML elements, forward the prop if it is a valid HTML attribute
        return isPropValid(propName);
    }
    // For other elements, forward all props
    return true;
}

export const ThemeProvider = ({ children }: ThemeProviderProps) => {
    return (
        <StyleSheetManager shouldForwardProp={shouldForwardProp}>
            <StyledComponentsThemeProvider theme={theme}>{children}</StyledComponentsThemeProvider>
        </StyleSheetManager>
    );
};
